import { c as _c } from "react/compiler-runtime";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { WAVE_VOTING_LABELS, WAVE_VOTE_STATS_LABELS } from "@/helpers/waves/waves.constants";
interface WaveWinnersDropHeaderTotalVotesProps {
  readonly winner: ApiWaveDecisionWinner;
}
export default function WaveWinnersDropHeaderTotalVotes(t0) {
  const $ = _c(10);
  const {
    winner
  } = t0;
  const voteStyle = winner.drop.rating < 0 ? "tw-text-rose-400" : "tw-text-iron-50";
  const t1 = `tw-font-medium ${voteStyle}`;
  let t2;
  if ($[0] !== winner.drop.rating) {
    t2 = formatNumberWithCommas(winner.drop.rating);
    $[0] = winner.drop.rating;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = WAVE_VOTING_LABELS[winner.drop.wave.voting_credit_type];
  let t5;
  if ($[5] !== t4) {
    t5 = <span className="tw-whitespace-nowrap tw-font-normal tw-text-iron-400">{t4}{" "}{WAVE_VOTE_STATS_LABELS.TOTAL}</span>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-text-sm tw-leading-5">{t3}{t5}</div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}